import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@clerk/react";
import { useMe } from "../components/MeContext";
import { ErrorBox, Loading } from "../components/kit";

const HOME: Record<string, string> = { customer: "/customer", vendor: "/vendor", ops: "/ops" };

export default function AppRedirect() {
  const { isLoaded, isSignedIn } = useAuth();
  const { me, loading, error, reload } = useMe();
  if (!isLoaded) return <Loading />;
  if (!isSignedIn) return <Navigate to="/sign-in" replace />;
  if (error) return <div className="mx-auto max-w-3xl p-6"><ErrorBox message={error} onRetry={reload} /></div>;
  if (loading || !me) return <div className="mx-auto max-w-3xl px-4"><Loading label="Checking access…" /></div>;
  if (me.kind && HOME[me.kind] && (me.kind !== "vendor" || me.org_id)) return <Navigate to={HOME[me.kind]} replace />;
  return (
    <div className="mx-auto max-w-2xl px-4 py-16" data-testid="no-access-panel">
      <h1 className="text-4xl font-extrabold">Awaiting invitation</h1>
      <p className="mt-4 text-sm text-[var(--muted)]">
        You are signed in as <strong>{me.email || "an unverified email"}</strong>, but this email has not been invited to the VergeServices preview.
        Ask Verge operations to send an invitation, then reload this page.
      </p>
      <div className="mt-6 flex flex-wrap gap-3">
        <button className="btn btn-dark" onClick={reload} data-testid="no-access-recheck-button">Check again</button>
        <a href="/apply" className="btn btn-primary" data-testid="no-access-apply-link">Apply as a service pro</a>
      </div>
    </div>
  );
}
